/* eslint-disable no-param-reassign */
import get from 'lodash/get';
import cookie from 'cookie';

const initialState = () => ({
  autocompleteQuery: '',
  autocompleteProductType: null,
  autocompleteGroup: null,
  session: {
    cart: {},
  },
  csrfToken: '',
});

export { initialState as state };

export const getters = {
  userSession: (state) => state.session.user,
  campaigns: (state) => get(state, 'session.session.campaigns', []),
};

export const mutations = {
  setCart(state, data) {
    state.cart = data;
  },

  setSession(state, data) {
    const [session, cookies] = data;
    state.session = session;

    // csrf cookie not created for some reason when hitting /browse as a anon new user.  Hack!
    // csrf needed for Experiments
    if (cookies) {
      state.csrfToken = cookies.find((c) => {
        const curCookie = cookie.parse(c);

        if (curCookie.csrftoken) {
          return c;
        }

        return false;
      }) || '';
    }
  },
  setAutocompleteQuery(state, data) {
    state.autocompleteQuery = data;
  },
  setAutocompleteProductType(state, data) {
    state.autocompleteProductType = data;
  },
  setAutocompleteGroup(state, data) {
    state.autocompleteGroup = data;
  },
};

export const actions = {
  nuxtServerInit({ dispatch }) {
    return dispatch('browse/fetch');
  },
};
